import * as React from 'react';
import * as _ from 'lodash';
import { Message, RecommendedCategories, Explanation, ExplanationTitle, ExplanationList, ExplanationListElement, IconWrapper, MessageLabel } from './styles';
import { DealerEngineCategories } from 'features/Dealers/Listings/Categories/state/types';
import ToolTip from 'components/ToolTip';
import { ReactComponent as IconToolTip } from 'common/images/icon-tootltip-orange.svg'
import { ReactComponent as IconInfo } from 'common/images/icon-info.svg'

export interface HoverableSuggestionsProps {
    categories: DealerEngineCategories
    onRecommendationsClick: () => void
}


const HoverableSuggestions = (props: HoverableSuggestionsProps) => {
    return (
        <Message>
            <MessageLabel>
                {
                    "Apply Dealer On"
                }
                &nbsp;
                </MessageLabel>
            <RecommendedCategories
                onClick={props.onRecommendationsClick}
            >
                {
                    "recommended categories"
                }
            </RecommendedCategories>
            <ToolTip
                renderIcon={renderIcon}
                renderBody={renderExplanation}
            />
        </Message>
    )

    function renderExplanation() {
        return (
            <Explanation>
                <ExplanationTitle>
                    Primary Category
                </ExplanationTitle>
                <ExplanationList>
                    {
                        props.categories.primaryCategory.name
                    }
                </ExplanationList>
                <ExplanationTitle>
                    Additional Categories
                </ExplanationTitle>
                <ExplanationList>
                    {
                        props.categories.additionalCategories.map(element => {
                            return (
                                <ExplanationListElement key={element.id}>
                                    {
                                        element.name
                                    }
                                </ExplanationListElement>
                            )
                        })
                    }
                </ExplanationList>
            </Explanation>
        )
    }

    function renderIcon() {
        return (
            <IconWrapper>
                <IconInfo />
            </IconWrapper>
        )
    }
}

export default HoverableSuggestions